import { Injectable } from '@angular/core';
import { portalConst } from '@app/config';
import { Observable } from 'rxjs';
import {
  Appointments,
  Bimesters,
  FilterEducationalData,
  OccurrencesSubjects,
  OccurrenceStudentSummary,
  Recomendations,
  RecomendationsByType,
  SaveOccurrenceData,
  SendEmailData,
  StudentEducationalOccurrences,
  StudentNotifications,
  StudentOccurrenceGetData,
  UpdateStudentOnScreenOccurrenceData,
} from '../models/academic.model';
import { ApiService, Resp } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class AppointmentsService {
  private _url = `${portalConst.api.academic}/v1/`;

  constructor(private api: ApiService) {}

  public filterEducational(data: FilterEducationalData): Observable<Resp<StudentNotifications[]>> {
    return this.api.get<StudentNotifications[]>(`${this._url}appointments/educational/filter`, data);
  }

  public sendEmail(data: SendEmailData): Observable<Resp<void>> {
    return this.api.get(`${this._url}appointments/email`, data);
  }

  public getRecomendations(): Observable<Resp<RecomendationsByType[]>> {
    return this.api.list(`${this._url}recomendations`);
  }

  public getOccurrenceRecomendations(): Observable<Resp<Recomendations[]>> {
    return this.api.list(`${portalConst.api.academic}/v1/appointments/recomendations`);
  }

  public getBimesters(): Observable<Resp<Bimesters[]>> {
    return this.api.list(`${this._url}entity-bimester`);
  }

  public studentEducationalOccurrences(
    req: StudentOccurrenceGetData,
  ): Observable<Resp<StudentEducationalOccurrences[]>> {
    return this.api.list(`${this._url}student-occurrences`, req);
  }

  public updateOccurrencesOnScreen(
    req: UpdateStudentOnScreenOccurrenceData,
  ): Observable<Resp<StudentEducationalOccurrences[]>> {
    return this.api.list(`${this._url}update-screen`, req);
  }

  public switchResponsible(id: number, data: any): Observable<any> {
    return this.api.put(`${this._url}appointments/educational/switch-responsible/${id}`, data);
  }

  public saveOccurrence(data: SaveOccurrenceData): Observable<Resp<void>> {
    return this.api.post(`${this._url}appointments`, data);
  }

  public updateOccurrence(id: number, data: Appointments): Observable<Resp<OccurrencesSubjects>> {
    return this.api.put(`${this._url}appointments/${id}`, data);
  }

  public deleteOccurrence(id: number): Observable<Resp<void>> {
    return this.api.delete(`${this._url}appointments/${id}`);
  }

  public print(data: any) {
    const query = this.api.resolveParams(data).toString();
    return `${this._url}report/letter-occurrence?${query}`;
  }

  public printDisciplinary(data: any) {
    const query = this.api.resolveParams(data).toString();
    return `${this._url}report/disciplinary?${query}`;
  }

  public printBatchOccurrences(req: any): Observable<any> {
    return this.api.post(`${this._url}report/print-batch`, req);
  }

  public printGeneral(data: any) {
    const query = this.api.resolveParams(data).toString();
    window.open(`${this._url}report/general?${query}`, '_blank');
  }

  public printDeliberative(data: any): string {
    const query = this.api.resolveParams(data).toString();
    return `${this._url}deliberative-form/print?${query}`;
  }

  public getStudentsByEntity(entityId: number, req?: any): Observable<Resp<OccurrenceStudentSummary[]>> {
    return this.api.get<OccurrenceStudentSummary[]>(`${this._url}entity/${entityId}/students`, req);
  }
}
